import React from 'react';

const StatusBadge = ({ stage }) => {
  const getStageConfig = (stage) => {
    const configs = {
      APPLIED: { label: 'Applied', colorClasses: 'bg-[#E3F2FD] text-[#1976D2]' },
      SHORTLISTED: { label: 'Shortlisted', colorClasses: 'bg-[#E8F5E9] text-[#2E7D32]' },
      AGREEMENT: { label: 'Agreement', colorClasses: 'bg-[#E8EAF6] text-[#3949AB]' },
      INTERVIEW: { label: 'Interview', colorClasses: 'bg-[#E0F2F1] text-[#00897B]' },
      PAYMENT: { label: 'Payment', colorClasses: 'bg-[#FFF3E0] text-[#EF6C00]' },
      DOCUMENT_VERIFICATION: { label: 'Documents', colorClasses: 'bg-[#E0F7FA] text-[#0097A7]' },
      EXAM: { label: 'Exam', colorClasses: 'bg-[#E8EAF6] text-[#3949AB]' },
      MEDICAL: { label: 'Medical', colorClasses: 'bg-[#FCE4EC] text-[#C2185B]' },
      TPC_PRACTISING: { label: 'TPC Practising', colorClasses: 'bg-[#E1F5FE] text-[#0277BD]' },
      ESD_APPROVAL: { label: 'ESD Approval', colorClasses: 'bg-[#E8F5E9] text-[#2E7D32]' },
      VISA_PROCESS: { label: 'Visa', colorClasses: 'bg-[#FFFDE7] text-[#F9A825]' },
      PRE_DEPARTURE: { label: 'Pre-Departure', colorClasses: 'bg-[#FFF8E1] text-[#F57C00]' },
      CLEARANCE: { label: 'Clearance', colorClasses: 'bg-[#E0F2F1] text-[#00796B]' },
      TICKET: { label: 'Ticket', colorClasses: 'bg-[#F9FBE7] text-[#AFB42B]' },
      DEPARTURE: { label: 'Departure', colorClasses: 'bg-[#FFF8E1] text-[#FF8F00]' },
      OFFER_LETTER: { label: 'Offer Letter', colorClasses: 'bg-[#F3E5F5] text-[#7B1FA2]' },
      COMPLETED: { label: 'Completed', colorClasses: 'bg-[#E8F5E9] text-[#388E3C]' },
      REJECTED: { label: 'Rejected', colorClasses: 'bg-[#FFEBEE] text-[#D32F2F]' },
      WITHDRAWN: { label: 'Withdrawn', colorClasses: 'bg-[#FBE9E7] text-[#BF360C]' },
      agreement_pending: { label: 'Agreement Pending', colorClasses: 'bg-[#E3F2FD] text-[#1976D2]' },
      agreement_accepted: { label: 'Agreement Accepted', colorClasses: 'bg-[#E8F5E9] text-[#388E3C]' },
      payment_pending: { label: 'Payment Pending', colorClasses: 'bg-[#FFF3E0] text-[#F57C00]' },
      payment_uploaded: { label: 'Payment Uploaded', colorClasses: 'bg-[#E0F7FA] text-[#0097A7]' },
      payment_verified: { label: 'Payment Verified', colorClasses: 'bg-[#E8F5E9] text-[#388E3C]' },
      esign_pending: { label: 'E-Sign Pending', colorClasses: 'bg-[#FFFDE7] text-[#F9A825]' },
      esign_completed: { label: 'E-Sign Completed', colorClasses: 'bg-[#E0F2F1] text-[#00897B]' },
      completed: { label: 'Completed', colorClasses: 'bg-[#E8F5E9] text-[#388E3C]' }
    };

    return configs[stage] || { label: stage, colorClasses: 'bg-[#F5F5F5] text-[#616161]' };
  };

  const config = getStageConfig(stage);

  return (
    <span className={`inline-block px-3 py-1 rounded-xl text-xs font-semibold uppercase tracking-wider ${config.colorClasses}`}>
      {config.label}
    </span>
  );
};

export default StatusBadge;
